import { DuctHeatLossGainInputType, InfiltrationInputType } from './types';

export const defaultSizingAttributes = {
  aboveGradeWalls: [],
  belowGradeWalls: [],
  ceilingsBelowRoof: [],
  ceilingsBelowAttic: [],
  floorsOverUnconditionedSpace: [],
  floorsOverExposedSpace: [],
  basementFloors: [],
  slabFloors: [],
  appliances: []
};

export const defaultInfiltration: InfiltrationInputType = {
  infiltrationEnvelope: 'Average',
  constructionType: 'Two Story House',
  numberOfFireplaces: 0
};

export const defaultDucts: DuctHeatLossGainInputType = {
  ductSystemType: 'Ducts in Conditioned Space',
  ductWallInsulation: 'R-4',
  ductLeakageClass: '0.12 / 0.24'
};

export const defaultAboveGradeWall = {
  isShaded: false,
  wallType: 'Frame' as const,
  studMaterial: 'Wood' as const,
  cavityInsulation: 'R-13' as const,
  boardInsulation: 'R-4' as const,
  hasInteriorFinish: true,
  exteriorFinish: 'Siding' as const,
  verticalGlass: [],
  solidDoors: []
};

export const defaultBelowGradeWall = {
  belowGradeDepth: 6 as const,
  wallType: 'Concrete Block' as const,
  insulationValue: 'None' as const,
  insulationType: 'None' as const,
  insulationCoverage: 'None' as const,
  blockCore: 'Open' as const,
  verticalGlass: [],
  solidDoors: []
};

export const defaultGlass = {
  roofOverhangFeet: 1 as const,
  distanceTopOfWindowToRoofOverhang: 1 as const,
  fenestrationType: 'Window' as const,
  material: 'Clear Glass' as const,
  panes: 'Single' as const,
  constructionType: 'Wood' as const,
  shadeType: 'Vertical or Horizontal Blinds with Slats At 45 Degrees' as const,
  groundCovering: 'Crushed Rock' as const,
  bugScreen: 'Full Indoor' as const,
  sash: 'Operable' as const
};

export const defaultDoor = {
  material: 'Wood' as const,
  stormMaterial: 'None' as const,
  core: 'Solid' as const
};

export const defaultCeilingBelowRoof = {
  hasRadiantBarrier: false,
  ceilingType: 'Below Roof Joists' as const,
  roofingMaterial: 'Asphalt Shingles' as const,
  roofingColor: 'Dark' as const,
  insulationValue: 'R-15' as const,
  deckMaterial: 'Plywood' as const,
  skylights: []
};

export const defaultCeilingOnExposedBeams = {
  hasRadiantBarrier: false,
  ceilingType: 'On Exposed Beams' as const,
  roofingMaterial: 'Asphalt Shingles' as const,
  roofingColor: 'Dark' as const,
  insulationValue: 'R-15' as const,
  deckMaterial: '1.5" Wood' as const,
  skylights: []
};

export const defaultCeilingBelowAttic = {
  hasEncapsulatedAttic: false,
  hasRadiantBarrier: false,
  ceilingType: 'Under Attic' as const,
  roofingMaterial: 'Asphalt Shingles' as const,
  roofingColor: 'Dark' as const,
  insulationValue: 'R-21' as const,
  ventilation: 'Vented' as const,
  atticTemperature: 130 as const
};

export const defaultSkylight = {
  length: 3,
  width: 3,
  panes: 'Single' as const,
  material: 'Clear Glass' as const,
  skylightType: 'Flat' as const,
  skylightCurb: 'Small' as const,
  sash: 'Metal' as const,
  constructionType:
    'Wood Curb No Insulation Plywood Shaft No Insulation' as const,
  glazingPanelInclination: '30 Degrees From Horizontal' as const
};

export const defaultFloorOverUnconditionedSpace = {
  floorType: 'Passive' as const,
  floorCover: 'Tile' as const,
  insulationValue: 'R-11' as const,
  exposedWallInsulationValue: 'None' as const,
  unconditionedSpaceInfiltrationType: 'Sealed' as const
};

export const defaultFloorOverExposedSpace = {
  floorType: 'Passive' as const,
  floorCover: 'Tile' as const,
  insulationValue: 'R-11' as const
};

export const defaultSlabFloor = {
  floorType: 'Passive' as const,
  insulationValue: 'None' as const,
  slabInsulationArrangement: 'None' as const,
  soilType: 'Light Moist' as const,
  feetBelowGrade: 1 as const
};

export const defaultBasementFloor = {
  isInsulatedBelowFloor: false,
  feetBelowGrade: 3 as const,
  shortestSideWidthFeet: 24 as const
};

export const defaultAppliance = {
  label: 'Appliance',
  wattage: 500 as const,
  inUseOutput: 1 as const,
  perHourUsage: 1 as const
};

export const smallWindow = {
  width: 3,
  height: 3
};

export const mediumWindow = {
  width: 5,
  height: 5
};

export const largeWindow = {
  width: 7,
  height: 7
};

export const slidingGlassDoor = {
  fenestrationType: 'Sliding Glass Door' as const,
  width: 3,
  height: 7
};

export const bayWindow = {
  fenestrationType: 'Bay Window' as const,
  width: 10,
  height: 10
};

export const frenchDoor = {
  sash: 'Operable' as const,
  fenestrationType: 'French Door' as const,
  width: 8,
  height: 7
};

export const solidDoor = {
  height: 6.5,
  width: 3
};
